var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"captcha",style:({height: _vm.computeSize}),attrs:{"src":_vm.src},on:{"click":_vm.clickHandler}})
}
var staticRenderFns = []

export { render, staticRenderFns }